export enum GraphApiCallType {
  GetUserInfo,
  GetMessageInfo,
  SetMailCustomProperties,
  GetSentEmailsToProcess,
  GetEventInfo,
  GetMessageAttachment,
  GetEventAttachment,
  TranslateExchangeIds,
}

export interface GraphApiCallArgs extends Record<string, any> {
  callType: GraphApiCallType
  mailbox: string
}
